import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';

export class DataPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:DataObjectReference' || elementType === 'epx:DataStoreReference';
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'dataProperties',
        label: i18n.dataObject || 'Data',
        entries: [
          {
            id: 'dataName',
            component: () => (
              <TextFieldEntry
                id="epx-data-name"
                label={i18n.name || 'Name'}
                value={props.name || ''}
                onChange={(val) => update('name', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
